/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiKeyDetailResponse } from '../models/api-key-detail-response';
import { ApiKeyList } from '../models/api-key-list';
import { ApiKeyResponse } from '../models/api-key-response';
import { createApiKey } from '../fn/api-keys/create-api-key';
import { CreateApiKey$Params } from '../fn/api-keys/create-api-key';
import { deleteApiKey } from '../fn/api-keys/delete-api-key';
import { DeleteApiKey$Params } from '../fn/api-keys/delete-api-key';
import { Empty } from '../models/empty';
import { getApiKey } from '../fn/api-keys/get-api-key';
import { GetApiKey$Params } from '../fn/api-keys/get-api-key';
import { getApiKeys } from '../fn/api-keys/get-api-keys';
import { GetApiKeys$Params } from '../fn/api-keys/get-api-keys';
import { getUsagePlan } from '../fn/api-keys/get-usage-plan';
import { GetUsagePlan$Params } from '../fn/api-keys/get-usage-plan';
import { putApiKey } from '../fn/api-keys/put-api-key';
import { PutApiKey$Params } from '../fn/api-keys/put-api-key';
import { putUsagePlan } from '../fn/api-keys/put-usage-plan';
import { PutUsagePlan$Params } from '../fn/api-keys/put-usage-plan';
import { UsagePlanResponse } from '../models/usage-plan-response';

@Injectable({ providedIn: 'root' })
export class ApiKeysService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiKeys()` */
  static readonly GetApiKeysPath = '/api-keys';

  /**
   * Gets all api-keys for the current tenant. (does not include api-key values).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiKeys$Response(params: GetApiKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyList>> {
    return getApiKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all api-keys for the current tenant. (does not include api-key values).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiKeys(params: GetApiKeys$Params, context?: HttpContext): Observable<ApiKeyList> {
    return this.getApiKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeyList>): ApiKeyList => r.body)
    );
  }

  /** Path part for operation `createApiKey()` */
  static readonly CreateApiKeyPath = '/api-keys';

  /**
   * Creates a new API Key (max of two API Keys per tenant).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiKey$Response(params: CreateApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyResponse>> {
    return createApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new API Key (max of two API Keys per tenant).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiKey(params: CreateApiKey$Params, context?: HttpContext): Observable<ApiKeyResponse> {
    return this.createApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeyResponse>): ApiKeyResponse => r.body)
    );
  }

  /** Path part for operation `getApiKey()` */
  static readonly GetApiKeyPath = '/api-keys/{apiKeyId}';

  /**
   * Fetches an api-key by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiKey$Response(params: GetApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyDetailResponse>> {
    return getApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches an api-key by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiKey(params: GetApiKey$Params, context?: HttpContext): Observable<ApiKeyDetailResponse> {
    return this.getApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeyDetailResponse>): ApiKeyDetailResponse => r.body)
    );
  }

  /** Path part for operation `putApiKey()` */
  static readonly PutApiKeyPath = '/api-keys/{apiKeyId}';

  /**
   * Updates the api-key.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putApiKey$Response(params: PutApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyResponse>> {
    return putApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates the api-key.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putApiKey(params: PutApiKey$Params, context?: HttpContext): Observable<ApiKeyResponse> {
    return this.putApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeyResponse>): ApiKeyResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiKey()` */
  static readonly DeleteApiKeyPath = '/api-keys/{apiKeyId}';

  /**
   * Deletes an api-key by it's ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiKey$Response(params: DeleteApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
    return deleteApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an api-key by it's ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiKey(params: DeleteApiKey$Params, context?: HttpContext): Observable<Empty> {
    return this.deleteApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<Empty>): Empty => r.body)
    );
  }

  /** Path part for operation `getUsagePlan()` */
  static readonly GetUsagePlanPath = '/usage-plan';

  /**
   * Returns the Tenant usage plan based on existing api keys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsagePlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsagePlan$Response(params: GetUsagePlan$Params, context?: HttpContext): Observable<StrictHttpResponse<UsagePlanResponse>> {
    return getUsagePlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the Tenant usage plan based on existing api keys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsagePlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsagePlan(params: GetUsagePlan$Params, context?: HttpContext): Observable<UsagePlanResponse> {
    return this.getUsagePlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsagePlanResponse>): UsagePlanResponse => r.body)
    );
  }

  /** Path part for operation `putUsagePlan()` */
  static readonly PutUsagePlanPath = '/usage-plan';

  /**
   * Updates an Usage Plan for a specified tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putUsagePlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUsagePlan$Response(params: PutUsagePlan$Params, context?: HttpContext): Observable<StrictHttpResponse<UsagePlanResponse>> {
    return putUsagePlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an Usage Plan for a specified tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putUsagePlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUsagePlan(params: PutUsagePlan$Params, context?: HttpContext): Observable<UsagePlanResponse> {
    return this.putUsagePlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsagePlanResponse>): UsagePlanResponse => r.body)
    );
  }

}
